import type { ExtensionConfig } from '@goto/shell'

const extensionConfig: ExtensionConfig = {
  id: '@ucc/cc-resolve',
  url: new URL('/experiences/cc-resolve/@ucc/cc-resolve-extension.mjs', location.origin),
  esModule: true,
}

export default extensionConfig
